import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(({
    root: {
       color: "white",
       paddingTop: 4, 
       paddingBottom: 3,
       paddingRight: 5,
       paddingLeft: 5,
       fontWeight: 400,

       "& .MuiSelect-select.MuiSelect-select" : {
           paddingRight: 10
       },

       "& .MuiSelect-icon" : {
        color: "white",
        position: "relative",
        fontSize: "large",
        }
    },

    link: {
        "textDecorationLine": "none !important"
    }
}));
